"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SrOnly = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Element (div by default, use the "as" prop to specify another element) visible only to screen readers.
 */
var SrOnly = _styledComponents["default"].div.withConfig({
  displayName: "SrOnly",
  componentId: "sc-yd3adh-0"
})(["position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0;"]);

exports.SrOnly = SrOnly;